'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiShoppingCart = function TiShoppingCart(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.6 8.9c-0.3-0.4-0.8-0.6-1.3-0.6h-23l-0.3-1.9c-0.2-0.8-0.9-1.4-1.7-1.4h-3.7c-0.9 0-1.7 0.7-1.7 1.7s0.8 1.6 1.7 1.6h2.3l3.1 18.6c0 0.1 0.1 0.2 0.1 0.2 0 0.1 0 0.2 0.1 0.3 0 0.1 0.1 0.2 0.2 0.3 0 0.1 0.1 0.1 0.1 0.2 0.1 0.1 0.3 0.1 0.4 0.2 0 0 0.1 0.1 0.2 0.1 0.1 0.1 0.3 0.1 0.6 0.1h18.3c0.9 0 1.7-0.7 1.7-1.6s-0.8-1.7-1.7-1.7h-16.9l-0.3-1.7h18.9c0.8 0 1.5-0.6 1.6-1.4l1.7-11.7c0.1-0.4-0.1-0.9-0.4-1.3z m-3.2 2.8l-0.5 3.3h-5.9v-3.3h6.4z m-8.1 0v3.3h-5v-3.3h5z m0 5v3.3h-5v-3.3h5z m-6.6-5v3.3h-5c-0.1 0-0.2 0-0.3 0.1l-0.5-3.4h5.8z m-5 5h5v3.3h-4.5l-0.5-3.3z m13.3 3.3v-3.3h5.7l-0.5 3.3h-5.2z m-8.3 12.5c0 1.4-1.2 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5z m15 0c0 1.4-1.2 2.5-2.5 2.5s-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5z' })
        )
    );
};

exports.default = TiShoppingCart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/shopping-cart.js
// module id = 1997
// module chunks = 0